import { Select } from '@percent/lemonade';

import { useMemo } from 'react';
import { useQuery } from '@percent/grants-nomination-form/hooks';
import { SelectOption } from '@percent/grants-nomination-form/api/nominationForm/nominationForm.types';
import { useTranslation } from 'react-i18next';
import { RegistrySelectProps } from './RegistrySelect.types';
import { getRegistriesAction } from '@percent/grants-nomination-form/api/registries/registries.actions';

export const RegistrySelect = ({ onChange, countryCode, value, ...props }: RegistrySelectProps) => {
  const { t } = useTranslation();

  const noRegistryOption = { label: t('typography.noRegistry'), value: 'unknown-registry' };

  const { data: registries, isFetching } = useQuery(
    [
      'getRegistries',
      {
        countryCode,
        supportedTypes: ['nonprofit'],
      },
    ],
    getRegistriesAction,
    {
      enabled: !!countryCode,
    },
  );

  const selectOptions: SelectOption[] = useMemo(
    () =>
      registries?.data.map((registry) => ({
        value: registry.name,
        label: registry.englishName,
      })) ?? [],
    [registries],
  );

  const defaultValue =
    value === noRegistryOption.value ? noRegistryOption : selectOptions.find((option) => option.value === value);

  return (
    <Select
      options={selectOptions}
      onChange={onChange}
      disabled={!countryCode}
      defaultValue={defaultValue}
      addOption={{
        ...noRegistryOption,
        onClick: () => {
          onChange(noRegistryOption);
        },
        hideIcon: true,
      }}
      isLoading={isFetching}
      searchable
      {...props}
    />
  );
};
